import React, { FC } from 'react';

import { get } from 'lodash';

import Skeleton from '../../../modules/skeleton';
import { Column } from '../../../modules/table';
import { Assets } from '../../../services/api/dto/Assets';

import './row-component.scss';

const styleMap: Record<string, string> = {
  number: 'number',
  issuer: 'issuer',
  inn: 'inn',
  owner: 'owner',
  ownerInn: 'ownerInn',
  issuedDate: 'date',
  status: 'status',
};

interface IProps {
  loading: boolean;
  rowData: Assets;
  columns: Column<Assets>[];
  onRowClick?: (id: string) => void;
}

const RowComponent: FC<IProps> = ({
  rowData,
  columns,
  onRowClick,
  loading,
}) => {
  const id = get(rowData, 'id', '');

  return loading ? (
    <Skeleton variant="rect" className="table-row" height={64} width="100%" />
  ) : (
    <div className="table-row" key={`assets-${id}`}>
      {columns.map((column, index) => {
        const columnData = column.dataGetter(rowData);

        return (
          <div
            className={`table-row__${styleMap[column.name]}`}
            style={{ ...column.headerStyle }}
            title={columnData}
            onClick={() => onRowClick && onRowClick(id)}
            key={`fin-token-row-${index}`}
          >
            {column.Component ? (
              <column.Component data={columnData} rowData={rowData} />
            ) : (
              columnData
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RowComponent;
